export default "__VITE_ASSET__77755bdb__"